var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-container" }, [
    _c(
      "div",
      { staticClass: "modal-header" },
      [
        _c("h4", { staticClass: "modal-title" }, [
          _vm._v("Set as Free (" + _vm._s(_vm.company) + ")"),
        ]),
        _c(
          "md-button",
          {
            staticClass: "md-simple md-just-icon md-round modal-default-button",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.$modal.hide($event)
              },
            },
          },
          [_c("md-icon", [_vm._v("clear")])],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "modal-body" },
      [
        _c(
          "form-wrapper",
          { staticClass: "form-wrapper", attrs: { validator: _vm.$v.model } },
          [
            _c(
              "md-datepicker",
              {
                ref: "mdDatePicker",
                attrs: { "md-immediately": "", "md-debounce": 10 },
                model: {
                  value: _vm.model.freeUntilDate,
                  callback: function ($$v) {
                    _vm.$set(_vm.model, "freeUntilDate", $$v)
                  },
                  expression: "model.freeUntilDate",
                },
              },
              [_c("label", [_vm._v("Free End Date")])]
            ),
            _c(
              "form-group",
              {
                attrs: {
                  name: "freeUsersAllowed",
                  label: "Maximum Free Users Allowed",
                },
              },
              [
                _c("md-input", {
                  model: {
                    value: _vm.model.freeUsersAllowed,
                    callback: function ($$v) {
                      _vm.$set(_vm.model, "freeUsersAllowed", $$v)
                    },
                    expression: "model.freeUsersAllowed",
                  },
                }),
              ],
              1
            ),
            _c(
              "form-group",
              { attrs: { name: "reason", label: "Reason" } },
              [
                _c("md-textarea", {
                  model: {
                    value: _vm.model.reason,
                    callback: function ($$v) {
                      _vm.$set(_vm.model, "reason", $$v)
                    },
                    expression: "model.reason",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "modal-footer" },
      [
        _c(
          "md-button",
          {
            staticClass: "dialog-button md-primary",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.changeBillingStatusToFree($event)
              },
            },
          },
          [_vm._v("Update")]
        ),
        _c(
          "md-button",
          {
            staticClass: "dialog-button md-default",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.$modal.hide($event)
              },
            },
          },
          [_vm._v("Cancel")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }